import React from "react";

export function ChartTopSummary(props) {
  const {
    mobileView,
    stockData,
    tickerFromLocalStorage,
    setting,
    stockPrice,
  } = props;

  return (
    <div className="flex justify-between">
      <div className={mobileView ? "w-full" : "w-full ml-12 mt-4"}>
        <div className="text-[#5f5f5f]">
          {stockData?.ticker?.name || "N/A"}
        </div>
        <div className="font-bold text-primaryColor">
          {stockData?.ticker?.ticker || tickerFromLocalStorage || setting?.symbol || "NA"}
        </div>
      </div>
      <div
        className={
          mobileView
            ? "bg-white border border-gray-300 rounded-lg px-2 py-1"
            : "bg-white border border-gray-300 rounded-lg mt-4  px-2 py-1 mr-8"
        }
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="price flex">
          {stockPrice || stockData?.ticker?.price?.toFixed(2) || "N/A"}
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            className="diff text-[12px] mr-3"
            style={{
              color: stockData?.ticker?.todaysChange < 0 ? "red" : "green",
            }}
          >
            {stockData?.ticker?.todaysChange?.toFixed(2) || "N/A"}
          </div>
          <div
            className="diff-percentage text-[12px]"
            style={{
              color: stockData?.ticker?.todaysChange < 0 ? "red" : "green",
            }}
          >
            {stockData?.ticker?.todaysChangePerc?.toFixed(2) + "%" || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
